<template>
	<div style="padding: 20px">
		<div class="Section0" style="layout-grid:15.6000pt;">
		<p class=MsoNormal align=center style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:center;
mso-outline-level:1;background:rgb(255,255,255);"><b><span style="mso-spacerun:'yes';font-family:微软雅黑;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-weight:bold;font-size:24.0000pt;
mso-font-kerning:18.0000pt;">
					<font face="微软雅黑">众诚汽车保险股份有限公司</font>
				</span></b><b><span style="mso-spacerun:'yes';font-family:微软雅黑;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-weight:bold;font-size:24.0000pt;
mso-font-kerning:18.0000pt;">
					<o:p></o:p>
				</span></b></p>
		<p class=MsoNormal align=center style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:center;
mso-outline-level:1;background:rgb(255,255,255);"><b><span style="mso-spacerun:'yes';font-family:微软雅黑;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-weight:bold;font-size:24.0000pt;
mso-font-kerning:18.0000pt;">
					<font face="微软雅黑">个人客户信息处理规则</font>
				</span></b><b><span style="mso-spacerun:'yes';font-family:微软雅黑;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-weight:bold;font-size:24.0000pt;
mso-font-kerning:18.0000pt;">
					<o:p></o:p>
				</span></b></p>
		<p class=MsoNormal align=center style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:center;
mso-outline-level:1;background:rgb(255,255,255);"><b><span style="mso-spacerun:'yes';font-family:微软雅黑;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-weight:bold;font-size:24.0000pt;
mso-font-kerning:18.0000pt;">
					<o:p>&nbsp;</o:p>
				</span></b></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;"><span style="mso-spacerun:'yes';font-family:宋体;mso-bidi-font-weight:bold;
font-size:11.0000pt;mso-font-kerning:0.0000pt;">
				<font face="宋体">更新日期：</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;mso-bidi-font-weight:bold;
font-size:11.0000pt;mso-font-kerning:0.0000pt;">2022年3月2日</span><span style="mso-spacerun:'yes';font-family:宋体;mso-bidi-font-weight:bold;
font-size:11.0000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;mso-bidi-font-weight:bold;
font-size:11.0000pt;mso-font-kerning:0.0000pt;">
				<font face="宋体">版本日期：</font>
				<font face="宋体">2</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;mso-bidi-font-weight:bold;
font-size:11.0000pt;mso-font-kerning:0.0000pt;">022</span><span style="mso-spacerun:'yes';font-family:宋体;mso-bidi-font-weight:bold;
font-size:11.0000pt;mso-font-kerning:0.0000pt;">
				<font face="宋体">年</font>
				<font face="宋体">3月2日</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;mso-bidi-font-weight:bold;
font-size:11.0000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;mso-bidi-font-weight:bold;
font-size:11.0000pt;mso-font-kerning:0.0000pt;">
				<o:p>&nbsp;</o:p>
			</span></p>
		<p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:微软雅黑;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:10.5000pt;mso-font-kerning:0.0000pt;">
				<font face="微软雅黑">尊敬的客户：您好！</font>
				<font face="微软雅黑">
					&nbsp;&nbsp;根据《中华人民共和国民法典》《中华人民共和国个人信息保护法》《中华人民共和国保险法》等相关法律法规规定，众诚汽车保险股份有限公司（以下称“众诚保险”）向您告知《众诚汽车保险股份有限公司个人客户信息处理规则》（以下简称“处理规则”），以下内容涉及您的切身利益，请您认真阅读。如有不清楚的地方请随时联系为您提供服务的众诚保险工作人员，或直接拨打
				</font>
			</span><span style="mso-spacerun:'yes';font-family:微软雅黑;mso-bidi-font-family:宋体;
font-size:10.5000pt;mso-font-kerning:0.0000pt;">
				<font face="微软雅黑">4</font>
			</span><span style="mso-spacerun:'yes';font-family:微软雅黑;mso-bidi-font-family:宋体;
font-size:10.5000pt;mso-font-kerning:0.0000pt;">008600600</span><span style="mso-spacerun:'yes';font-family:微软雅黑;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:10.5000pt;mso-font-kerning:0.0000pt;">
				<font face="微软雅黑">服务热线，将有工作人员为您解答。</font>
			</span><span style="mso-spacerun:'yes';font-family:微软雅黑;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:10.5000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;
mso-outline-level:2;background:rgb(255,255,255);"><b><span style="mso-spacerun:'yes';font-family:微软雅黑;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-weight:bold;font-size:18.0000pt;
mso-font-kerning:0.0000pt;">
					<font face="微软雅黑">一、个人信息处理者名称和联系方式</font>
				</span></b><b><span style="mso-spacerun:'yes';font-family:微软雅黑;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-weight:bold;font-size:18.0000pt;
mso-font-kerning:0.0000pt;">
					<o:p></o:p>
				</span></b></p>
		<p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:微软雅黑;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:10.5000pt;mso-font-kerning:0.0000pt;">
				<font face="微软雅黑">您的个人信息可能会被以下信息处理者处理：众诚汽车保险股份有限公司（以下简称</font>
				<font face="微软雅黑">“众诚保险”）、众诚汽车保险股份有限公司服务供应商（以下简称“众诚保险供应商”）、众诚汽车保险股份有限公司直接或间接控股的公司（以下简称“众诚保险控股公司”）。
					以上信息处理者的联系方式为：</font>
			</span><span style="mso-spacerun:'yes';font-family:微软雅黑;mso-bidi-font-family:宋体;
font-size:10.5000pt;mso-font-kerning:0.0000pt;">
				<font face="微软雅黑">4</font>
			</span><span style="mso-spacerun:'yes';font-family:微软雅黑;mso-bidi-font-family:宋体;
font-size:10.5000pt;mso-font-kerning:0.0000pt;">008600600</span><span style="mso-spacerun:'yes';font-family:微软雅黑;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:10.5000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;
mso-outline-level:2;background:rgb(255,255,255);"><b><span style="mso-spacerun:'yes';font-family:微软雅黑;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-weight:bold;font-size:18.0000pt;
mso-font-kerning:0.0000pt;">
					<font face="微软雅黑">二、处理的个人信息种类</font>
				</span></b><b><span style="mso-spacerun:'yes';font-family:微软雅黑;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-weight:bold;font-size:18.0000pt;
mso-font-kerning:0.0000pt;">
					<o:p></o:p>
				</span></b></p>
		<p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:微软雅黑;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:10.5000pt;mso-font-kerning:0.0000pt;">
				<font face="微软雅黑">
					根据《个人信息保护法》的规定，您的个人信息分为：普通个人信息和敏感个人信息。您的普通个人信息包括：姓名、身份证件信息、国籍、职业、联系地址与联系方式等。您的敏感个人信息包括：生物识别、特定身份、医疗健康、金融账户、行踪轨迹。
				</font>
			</span><span style="mso-spacerun:'yes';font-family:微软雅黑;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:10.5000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;
mso-outline-level:2;background:rgb(255,255,255);"><b><span style="mso-spacerun:'yes';font-family:微软雅黑;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-weight:bold;font-size:18.0000pt;
mso-font-kerning:0.0000pt;">
					<font face="微软雅黑">三、个人信息处理目的、处理方式与保存期限</font>
				</span></b><b><span style="mso-spacerun:'yes';font-family:微软雅黑;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-weight:bold;font-size:18.0000pt;
mso-font-kerning:0.0000pt;">
					<o:p></o:p>
				</span></b></p>
		<p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:微软雅黑;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:10.5000pt;mso-font-kerning:0.0000pt;">
				<font face="微软雅黑">1、众诚保险会使用您的普通个人信息及部分敏感信息以便完成保险合同的订立和履行。</font>
			</span><span style="mso-spacerun:'yes';font-family:微软雅黑;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:10.5000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:微软雅黑;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:10.5000pt;mso-font-kerning:0.0000pt;">2</span><span style="mso-spacerun:'yes';font-family:微软雅黑;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:10.5000pt;mso-font-kerning:0.0000pt;">
				<font face="微软雅黑">、众诚保险及其供应商会使用您的普通个人信息及部分敏感信息进行真实性核验、现场或远程查勘定损，以便向您提供保险理赔等服务。</font>
			</span><span style="mso-spacerun:'yes';font-family:微软雅黑;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:10.5000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:微软雅黑;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:10.5000pt;mso-font-kerning:0.0000pt;">3</span><span style="mso-spacerun:'yes';font-family:微软雅黑;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:10.5000pt;mso-font-kerning:0.0000pt;">
				<font face="微软雅黑">、众诚保险及众诚保险供应商会使用您的普通个人信息及部分敏感信息进行数据分析，以便更好地向您提供风险防范、增值服务、风险评估和提醒等客户服务。</font>
			</span><span style="mso-spacerun:'yes';font-family:微软雅黑;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:10.5000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:微软雅黑;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:10.5000pt;mso-font-kerning:0.0000pt;">4</span><span style="mso-spacerun:'yes';font-family:微软雅黑;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:10.5000pt;mso-font-kerning:0.0000pt;">
				<font face="微软雅黑">、众诚保险会使用您的普通个人信息向您推送续保提醒、理赔款到账提醒等服务，以及向您推荐保险产品和相关服务。</font>
			</span><span style="mso-spacerun:'yes';font-family:微软雅黑;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:10.5000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:微软雅黑;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:10.5000pt;mso-font-kerning:0.0000pt;">5</span><span style="mso-spacerun:'yes';font-family:微软雅黑;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:10.5000pt;mso-font-kerning:0.0000pt;">
				<font face="微软雅黑">、众诚保险控股公司会使用您的普通个人信息向您推荐保险产品和相关服务。</font>
				<font face="微软雅黑">您的个人信息在众诚保险的保存期限为</font>
				<font face="微软雅黑">“为实现处理目的所必要的最短时间”，且不低于《保险法》规定的最低保管期限。</font>
			</span><span style="mso-spacerun:'yes';font-family:微软雅黑;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:10.5000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;
mso-outline-level:2;background:rgb(255,255,255);"><b><span style="mso-spacerun:'yes';font-family:微软雅黑;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-weight:bold;font-size:18.0000pt;
mso-font-kerning:0.0000pt;">
					<font face="微软雅黑">四、根据《个人信息保护法》，您享有的权利</font>
				</span></b><b><span style="mso-spacerun:'yes';font-family:微软雅黑;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-weight:bold;font-size:18.0000pt;
mso-font-kerning:0.0000pt;">
					<o:p></o:p>
				</span></b></p>
		<p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:微软雅黑;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:10.5000pt;mso-font-kerning:0.0000pt;">
				<font face="微软雅黑">1.您对个人信息的处理享有知情权、决定权，有权限制或者拒绝他人对您的个人信息进行处理；</font>
			</span><span style="mso-spacerun:'yes';font-family:微软雅黑;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:10.5000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:微软雅黑;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:10.5000pt;mso-font-kerning:0.0000pt;">
				<font face="微软雅黑">2.您有权查阅、复制个人信息；有权要求将个人信息转移至您指定的、且符合国家网信部门规定条件的个人信息处理者；</font>
			</span><span style="mso-spacerun:'yes';font-family:微软雅黑;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:10.5000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:微软雅黑;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:10.5000pt;mso-font-kerning:0.0000pt;">
				<font face="微软雅黑">3.您发现个人信息不准确或者不完整的，有权请求对个人信息更正、补充；</font>
			</span><span style="mso-spacerun:'yes';font-family:微软雅黑;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:10.5000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:微软雅黑;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:10.5000pt;mso-font-kerning:0.0000pt;">
				<font face="微软雅黑">
					4.有下列情形之一的，个人信息处理者应当主动删除个人信息；个人信息处理者未删除的，您有权请求删除：（1）处理目的已实现、无法实现或者为实现处理目的不再必要；（2）个人信息处理者停止提供产品或者服务，或者保存期限已届满；（3）您撤回同意；（4）个人信息处理者违反法律、行政法规或者违反约定处理个人信息；（5）法律、行政法规规定的其他情形。法律、行政法规规定的保存期限未届满，或者删除个人信息从技术上难以实现的，个人信息处理者应当停止除存储和采取必要的安全保护措施之外的处理。5.您有权要求个人信息处理者对个人信息处理规则进行解释说明；
				</font>
			</span><span style="mso-spacerun:'yes';font-family:微软雅黑;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:10.5000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:微软雅黑;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:10.5000pt;mso-font-kerning:0.0000pt;">
				<font face="微软雅黑">6.自然人死亡的，其近亲属为了自身的合法、正当利益，可以对死者的相关个人信息行使本条款规定的查阅、复制、更正、删除等权利；死者生前另有安排的除外；</font>
			</span><span style="mso-spacerun:'yes';font-family:微软雅黑;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:10.5000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:微软雅黑;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:10.5000pt;mso-font-kerning:0.0000pt;">
				<font face="微软雅黑">7.个人信息处理者拒绝个人行使权利的请求的，您可以依法向人民法院提起诉讼。</font>
			</span><span style="mso-spacerun:'yes';font-family:微软雅黑;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:10.5000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;
mso-outline-level:2;background:rgb(255,255,255);"><b><span style="mso-spacerun:'yes';font-family:微软雅黑;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-weight:bold;font-size:18.0000pt;
mso-font-kerning:0.0000pt;">
					<font face="微软雅黑">五、个人行使权利方式与程序</font>
				</span></b><b><span style="mso-spacerun:'yes';font-family:微软雅黑;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-weight:bold;font-size:18.0000pt;
mso-font-kerning:0.0000pt;">
					<o:p></o:p>
				</span></b></p>
		<p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:微软雅黑;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:10.5000pt;mso-font-kerning:0.0000pt;">
				<font face="微软雅黑">您依法享有《个人信息保护法》赋予您的相关权利，您可以拨打</font>
			</span><span style="mso-spacerun:'yes';font-family:微软雅黑;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:10.5000pt;mso-font-kerning:0.0000pt;">4008600600</span><span style="mso-spacerun:'yes';font-family:微软雅黑;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:10.5000pt;mso-font-kerning:0.0000pt;">
				<font face="微软雅黑">客服热线，或者至众诚保险各营业场所行使相关权利。</font>
			</span><span style="mso-spacerun:'yes';font-family:微软雅黑;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:10.5000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;
mso-outline-level:2;background:rgb(255,255,255);"><b><span style="mso-spacerun:'yes';font-family:微软雅黑;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-weight:bold;font-size:18.0000pt;
mso-font-kerning:0.0000pt;">
					<font face="微软雅黑">六、个人信息处理者的义务</font>
				</span></b><b><span style="mso-spacerun:'yes';font-family:微软雅黑;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-weight:bold;font-size:18.0000pt;
mso-font-kerning:0.0000pt;">
					<o:p></o:p>
				</span></b></p>
		<p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:微软雅黑;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:10.5000pt;mso-font-kerning:0.0000pt;">
				<font face="微软雅黑">
					根据《个人信息保护法》，个人信息处理者应当履行以下义务：个人信息处理者应当采取充分措施确保个人信息处理活动符合法律、行政法规的规定，并防止未经授权的访问以及个人信息泄露、篡改、丢失；个人信息个人信息处理者应当公开个人信息保护负责人的联系方式；个人信息处理者应当定期对其处理个人信息遵守法律、行政法规的情况进行合规审计；个人信息处理者应当在处理个人敏感信息、自动化决策、向他人提供个人信息等事项前进行个人信息保护影响评估并记录；发生或者可能发生个人信息泄露、篡改、丢失的，个人信息处理者应当立即采取补救措施，并通知履行个人信息保护职责的部门和个人。
				</font>
			</span><span style="mso-spacerun:'yes';font-family:微软雅黑;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:10.5000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:微软雅黑;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:10.5000pt;mso-font-kerning:0.0000pt;">
				<font face="微软雅黑">普通个人信息授权书</font>
			</span><span style="mso-spacerun:'yes';font-family:微软雅黑;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:10.5000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:微软雅黑;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:10.5000pt;mso-font-kerning:0.0000pt;">
				<font face="微软雅黑">
					&nbsp;本人已认真阅读并理解《众诚汽车保险股份有限公司个人客户信息处理规则》，同意授权众诚汽车保险股份有限公司、众诚汽车保险股份有限公司直接或间接控股的公司、众诚汽车保险股份有限公司服务供应商按照《众诚汽车保险股份有限公司个人客户信息处理规则》处理本人信息。
					本授权自本授权书签署时生效、具有独立法律效力，不受保险合同成立与否及效力状态变化的影响。</font>
			</span><span style="mso-spacerun:'yes';font-family:微软雅黑;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:10.5000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal align=right style="word-break:break-all;mso-pagination:widow-orphan;text-align:right;
background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:微软雅黑;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:10.5000pt;mso-font-kerning:0.0000pt;">
				<font face="微软雅黑">签名：</font>
			</span><span style="mso-spacerun:'yes';font-family:微软雅黑;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:10.5000pt;mso-font-kerning:0.0000pt;">&nbsp;</span><span style="mso-spacerun:'yes';font-family:微软雅黑;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:10.5000pt;mso-font-kerning:0.0000pt;">
				<font face="微软雅黑">日期：</font>
			</span><span style="mso-spacerun:'yes';font-family:微软雅黑;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:10.5000pt;mso-font-kerning:0.0000pt;">&nbsp;&nbsp;</span><span style="mso-spacerun:'yes';font-family:微软雅黑;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:10.5000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:微软雅黑;mso-bidi-font-family:宋体;
color:rgb(25,137,250);font-size:10.5000pt;mso-font-kerning:0.0000pt;">
				<font face="微软雅黑">敏感个人信息授权书</font>
			</span><span style="mso-spacerun:'yes';font-family:微软雅黑;mso-bidi-font-family:宋体;
color:rgb(25,137,250);font-size:10.5000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:微软雅黑;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:10.5000pt;mso-font-kerning:0.0000pt;">
				<font face="微软雅黑">
					&nbsp;本人已认真阅读并理解《众诚汽车保险股份有限公司个人客户信息处理规则》，同意授权众诚汽车保险股份有限公司、众诚汽车保险股份有限公司直接或间接控股的公司、众诚汽车保险股份有限公司服务供应商按照《众诚汽车保险股份有限公司个人客户信息处理规则》处理本人敏感个人信息。
					本授权自本授权书签署时生效、具有独立法律效力，不受保险合同成立与否及效力状态变化的影响。&nbsp;</font>
			</span><span style="mso-spacerun:'yes';font-family:微软雅黑;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:10.5000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal align=right style="word-break:break-all;mso-pagination:widow-orphan;text-align:right;
background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:微软雅黑;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:10.5000pt;mso-font-kerning:0.0000pt;">
				<font face="微软雅黑">签名：</font>
			</span><span style="mso-spacerun:'yes';font-family:微软雅黑;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:10.5000pt;mso-font-kerning:0.0000pt;">&nbsp;</span><span style="mso-spacerun:'yes';font-family:微软雅黑;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:10.5000pt;mso-font-kerning:0.0000pt;">
				<font face="微软雅黑">日期：</font>
			</span><span style="mso-spacerun:'yes';font-family:微软雅黑;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:10.5000pt;mso-font-kerning:0.0000pt;">&nbsp;&nbsp;</span><span style="mso-spacerun:'yes';font-family:微软雅黑;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:10.5000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:微软雅黑;mso-bidi-font-family:宋体;
color:rgb(25,137,250);font-size:10.5000pt;mso-font-kerning:0.0000pt;">
				<font face="微软雅黑">未满</font>
				<font face="微软雅黑">14周岁未成年人敏感个人信息授权书</font>
			</span><span style="mso-spacerun:'yes';font-family:微软雅黑;mso-bidi-font-family:宋体;
color:rgb(25,137,250);font-size:10.5000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:微软雅黑;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:10.5000pt;mso-font-kerning:0.0000pt;">
				<font face="微软雅黑">&nbsp;本人确认，本人是未满14周岁未成年人的父母或监护人。
					本人已认真阅读并理解《众诚汽车保险股份有限公司客户信息处理规则》，同意授权众诚汽车保险股份有限公司、众诚汽车保险股份有限公司直接或间接控股的公司、众诚汽车保险股份有限公司服务供应商按照《众诚汽车保险股份有限公司客户信息处理规则》处理本人未满14周岁子女或未满14周岁被监护人的敏感个人信息。
					本授权自本授权书签署时生效、具有独立法律效力，不受保险合同成立与否及效力状态变化的影响。</font>
			</span><span style="mso-spacerun:'yes';font-family:微软雅黑;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:10.5000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal align=right style="word-break:break-all;mso-pagination:widow-orphan;text-align:right;
background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:微软雅黑;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:10.5000pt;mso-font-kerning:0.0000pt;">
				<font face="微软雅黑">签名：</font> &nbsp;
			</span><span style="mso-spacerun:'yes';font-family:微软雅黑;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:10.5000pt;mso-font-kerning:0.0000pt;">&nbsp;&nbsp;</span><span style="mso-spacerun:'yes';font-family:微软雅黑;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:10.5000pt;mso-font-kerning:0.0000pt;">
				<font face="微软雅黑">日期：</font>
			</span><span style="mso-spacerun:'yes';font-family:微软雅黑;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:10.5000pt;mso-font-kerning:0.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="mso-spacerun:'yes';font-family:微软雅黑;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:10.5000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
				<o:p>&nbsp;</o:p>
			</span></p>
		<p class=MsoNormal><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
				<o:p>&nbsp;</o:p>
			</span></p>
	</div>
	</div>
</template>

<script>
// 此页面为 word 文档导出页面
export default {
  data() {
    return {

    };
  },
  async mounted() {

  },
  methods: {
  }
};
</script>

<style lang="scss">
		@font-face {
			font-family: "Times New Roman";
		}

		@font-face {
			font-family: "宋体";
		}

		@font-face {
			font-family: "Calibri";
		}

		@font-face {
			font-family: "Wingdings";
		}

		@font-face {
			font-family: "微软雅黑";
		}

		p.MsoNormal {
			mso-style-name: 正文;
			mso-style-parent: "";
			margin: 0pt;
			margin-bottom: .0001pt;
			mso-pagination: none;
			text-align: justify;
			text-justify: inter-ideograph;
			font-family: Calibri;
			mso-fareast-font-family: 宋体;
			mso-bidi-font-family: 'Times New Roman';
			font-size: 10.5000pt;
			mso-font-kerning: 1.0000pt;
		}

		span.10 {
			font-family: Calibri;
		}

		span.15 {
			font-family: Calibri;
			font-size: 10.5000pt;
		}

		span.16 {
			font-family: Calibri;
			font-size: 9.0000pt;
		}

		span.17 {
			font-family: Calibri;
			font-size: 9.0000pt;
		}

		span.18 {
			font-family: Calibri;
		}

		span.19 {
			font-family: Calibri;
			font-weight: bold;
		}

		span.20 {
			font-family: Calibri;
			font-size: 9.0000pt;
		}

		p.MsoFooter {
			mso-style-name: 页脚;
			mso-style-noshow: yes;
			margin: 0pt;
			margin-bottom: .0001pt;
			layout-grid-mode: char;
			mso-pagination: none;
			text-align: left;
			font-family: Calibri;
			mso-fareast-font-family: 宋体;
			mso-bidi-font-family: 'Times New Roman';
			font-size: 9.0000pt;
			mso-font-kerning: 1.0000pt;
		}

		p.MsoCommentText {
			mso-style-name: 批注文字;
			mso-style-noshow: yes;
			margin: 0pt;
			margin-bottom: .0001pt;
			mso-pagination: none;
			text-align: left;
			font-family: Calibri;
			mso-fareast-font-family: 宋体;
			mso-bidi-font-family: 'Times New Roman';
			font-size: 10.5000pt;
			mso-font-kerning: 1.0000pt;
		}

		p.MsoAcetate {
			mso-style-name: 批注框文本;
			mso-style-noshow: yes;
			margin: 0pt;
			margin-bottom: .0001pt;
			mso-pagination: none;
			text-align: justify;
			text-justify: inter-ideograph;
			font-family: Calibri;
			mso-fareast-font-family: 宋体;
			mso-bidi-font-family: 'Times New Roman';
			font-size: 9.0000pt;
			mso-font-kerning: 1.0000pt;
		}

		p.MsoCommentSubject {
			mso-style-name: 批注主题;
			mso-style-noshow: yes;
			mso-style-parent: 批注文字;
			mso-style-next: 批注文字;
			margin: 0pt;
			margin-bottom: .0001pt;
			mso-pagination: none;
			text-align: left;
			font-family: Calibri;
			mso-fareast-font-family: 宋体;
			mso-bidi-font-family: 'Times New Roman';
			font-weight: bold;
			font-size: 10.5000pt;
			mso-font-kerning: 1.0000pt;
		}

		p.MsoHeader {
			mso-style-name: 页眉;
			mso-style-noshow: yes;
			margin: 0pt;
			margin-bottom: .0001pt;
			border-bottom: 1.0000pt solid windowtext;
			mso-border-bottom-alt: 0.7500pt solid windowtext;
			padding: 0pt 0pt 1pt 0pt;
			layout-grid-mode: char;
			mso-pagination: none;
			text-align: center;
			font-family: Calibri;
			mso-fareast-font-family: 宋体;
			mso-bidi-font-family: 'Times New Roman';
			font-size: 9.0000pt;
			mso-font-kerning: 1.0000pt;
		}

		span.msoIns {
			mso-style-type: export-only;
			mso-style-name: "";
			text-decoration: underline;
			text-underline: single;
			color: blue;
		}

		span.msoDel {
			mso-style-type: export-only;
			mso-style-name: "";
			text-decoration: line-through;
			color: red;
		}

		table.MsoNormalTable {
			mso-style-name: 普通表格;
			mso-style-parent: "";
			mso-style-noshow: yes;
			mso-tstyle-rowband-size: 0;
			mso-tstyle-colband-size: 0;
			mso-padding-alt: 0.0000pt 5.4000pt 0.0000pt 5.4000pt;
			mso-para-margin: 0pt;
			mso-para-margin-bottom: .0001pt;
			mso-pagination: widow-orphan;
			font-family: 'Times New Roman';
			font-size: 10.0000pt;
			mso-ansi-language: #0400;
			mso-fareast-language: #0400;
			mso-bidi-language: #0400;
		}

		@page {
			mso-page-border-surround-header: no;
			mso-page-border-surround-footer: no;
		}

		@page Section0 {
			margin-top: 72.0000pt;
			margin-bottom: 72.0000pt;
			margin-left: 90.0000pt;
			margin-right: 90.0000pt;
			size: 595.3000pt 841.9000pt;
			layout-grid: 15.6000pt;
			mso-header-margin: 42.5500pt;
			mso-footer-margin: 49.6000pt;
		}

		div.Section0 {
			page: Section0;
		}
	</style>
